<script setup lang="ts">
    import { InputRow, DatePicker, Combobox } from '@/components/ui/form';
    import { computed } from 'vue';
    import type { SelectOption } from '@/types';
    import { useTaskTemplateData } from '@/composables/useTaskTemplateData';

    const props = defineProps<{
        form: any;
    }>();

    const { taskTemplates, isTaskTemplatesPending } = useTaskTemplateData();

    const templateOptions = computed<SelectOption[]>(() => {
        return Object.entries(taskTemplates.value).map(([value, label]) => ({
            value,
            label: label as string,
        }));
    });
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="selected_template"
            label="dashboards.selected_template"
        >
            <Combobox
                v-model="form.selected_template"
                :options="templateOptions"
                :show-remove-button="false"
                :loading="isTaskTemplatesPending"
            />
        </InputRow>

        <InputRow
            :form="form"
            name="tasks_deadline"
            label="dashboards.tasks_deadline"
        >
            <DatePicker v-model="form.tasks_deadline" />
        </InputRow>
    </div>
</template>
